import type { NsDict } from '../ru';

export const table: NsDict<'table'> = {
  'head.leaveHint': 'You will remain a participant until the end of the game',
  'head.lobby': '← Games',
  'head.title': 'Table {ante|cr}',
  'head.replay': 'Historical replay',
  'head.live': 'Live',
  'head.synthetic': 'Synthetic data',
  'pot.pot': 'Pot',
  'pot.ante': 'Ante N',

  'feed.title': 'Player moves',
  'feed.hint': 'forecasts hidden until settlement',
  'feed.empty': 'No moves yet',
  'feed.ante': 'ante',
  'feed.round': 'round {n}',
  'reveal.title': 'Information reveal',
  'reveal.commitment': 'commitment {hash}…',
  'reveal.compositionHidden': 'Composition hidden until round 3',

  'ready.spectator': 'You are watching this table.',
  'ready.confirmed': 'Participation confirmed.',
  'ready.anteAtStart': 'The ante of {amount|cr} will be paid at the start.',
  'ready.cancel': 'Withdraw',
  'ready.join': 'Join the game · ante {amount|cr}',
  'ready.joinNext': 'Join the next game · ante {amount|cr}',
  'ready.notEnough': 'Not enough credits for the ante.',

  'seats.participants': 'Participants',
  'seats.atTable': 'At the table',
  'seats.count': '{n}/{max} · amounts in cr',
  'seats.statsTitle': 'Player stats: games {games}, win rate {winRate}, net result {net} cr',
  'seats.colPlayer': 'Player',
  'seats.colRound': 'Round',
  'seats.colRoundHint': 'Bet in the current round, cr',
  'seats.colCommitted': 'In pot',
  'seats.colCommittedHint': 'Total put into the pot this game, cr',
  'seats.colStack': 'Stack',
  'seats.colStackHint': 'Available stack, cr',
  'seats.colStatus': 'Status',
  'seats.colBalance': 'Balance',
  'seats.turn': 'turn · {s} s',
  'seats.me': 'you',
  'seats.offline': 'offline',
  'seats.inGame': 'in game',
  'seats.ready': 'ready',
  'seats.waiting': 'waiting',
  'seats.free': 'free',

  'stage.chart': '1 · Chart',
  'stage.chartHint': 'direction',
  'stage.scale': '2 · Scale',
  'stage.scaleHint': 'prices and points',
  'stage.composition': '3 · Composition',
  'stage.compositionHint': 'number of points',
  'stage.candle': 'Candle',
  'stage.candleHint': 'waiting for close',
  'stage.settle': 'Settlement',
  'stage.settleHint': 'result',
  'stage.nextIn': 'Next game sign-up in',

  'controls.spectator': 'You are watching this game. You can join from the next game.',
  'controls.aria': 'Your forecast and actions',
  'controls.forecast': 'Forecast',
  'controls.forecastLocked': 'locked',
  'controls.youFolded': 'you folded',
  'controls.lockIn': 'locks in {time}',
  'controls.direction': 'Direction',
  'controls.up': 'Up',
  'controls.down': 'Down',
  'controls.points': 'Points',
  'controls.pointsRequired': 'required before lock',
  'controls.pointsOptional': 'preliminary, can be set later',
  'controls.pointsLess': 'decrease by {tick}',
  'controls.pointsMore': 'increase by {tick}',
  'controls.pointsInvalid': 'Points must be positive and a multiple of {tick}',
  'controls.pointsEnter': 'Enter the number of points',
  'controls.noticeChooseDirection': 'Choose a direction — without it you cannot put in credits. In round 3 the direction can no longer be chosen.',
  'controls.noticeNoDirectionRound3': 'No direction chosen, and in round 3 it can no longer be chosen: you will be out at lock.',
  'controls.noticeRound2': 'In round 3 the direction cannot be changed — only the number of points.',
  'controls.noticeRound3': 'Direction locked: in round 3 only the number of points can change.',
  'controls.noticeNoPoints': 'Enter the number of points: without it you will be out at lock in {s} s.',

  'controls.bet': 'Bet',
  'controls.bettingClosed': 'round {n} · betting closed',
  'controls.yourTurn': 'your turn · {s} s',
  'controls.theirTurn': '{name} to act · {s} s',
  'controls.roundBet': 'Round bet',
  'controls.toCall': 'To call',
  'controls.raises': 'Raises',
  'controls.raisesOf': '{n} of {max}',
  'controls.statusFolded': 'You folded — your participation in this game is over.',
  'controls.statusAllIn': 'You are all-in: no more bets, but you can change your forecast until lock.',
  'controls.statusPrep': 'The first betting round starts in {time}.',
  'controls.statusNextRound': 'All participants have acted. The next betting round opens in {time} {reveal}.',
  'controls.nextRevealScale': 'together with the price scale',
  'controls.nextRevealComposition': 'together with the stock composition',
  'controls.statusLockIn': 'All participants have acted. Forecasts will be locked in {time}.',
  'controls.statusWait': 'Wait for your turn. You can choose a pre-action in advance.',
  'controls.statusRaiseLimit': 'The raise limit for this round is used up — call or fold.',
  'controls.presetMin': 'Min',
  'controls.presetHalfPot': '½ pot',
  'controls.presetPot': 'Pot',
  'controls.presetMax': 'Max',
  'controls.betAmount': 'Bet amount',
  'controls.raiseTo': 'Raise to',
  'controls.range': 'from {min|cr} to {max|cr}',
  'controls.fold': 'Fold',
  'controls.check': 'Check',
  'controls.call': 'Call',
  'controls.raise': 'Raise',
  'controls.betAction': 'Bet',
  'controls.allIn': 'All-in',
  'controls.noDirection': 'To put in credits, choose a forecast direction.',
  'controls.foldTitle': 'Fold',
  'controls.foldConfirm': 'Fold',
  'controls.foldBody': 'You will leave the game. The {amount|cr} you put in stay in the pot and are returned only if the game is cancelled.',
  'controls.dontAsk': 'Don’t ask again',

  'pre.title': 'Pre-action',
  'pre.planned': 'scheduled',
  'pre.none': 'None',
  'pre.noneHint': 'No pre-action: you decide yourself on your turn.',
  'pre.checkOnly': 'Check',
  'pre.checkOnlyHint': 'Check if there is no bet. If someone has bet, the decision stays with you.',
  'pre.checkFold': 'Check / fold',
  'pre.checkFoldHint': 'Check if there is no bet; fold if someone has bet.',
  'pre.callUpTo': 'Call up to limit',
  'pre.callUpToHint': 'Call if the amount to call is within the limit; check if there is no bet. A bet above the limit — you decide yourself.',
  'pre.limit': 'Call limit',
  'pre.limitHint': 'above it — you decide',
  'pre.onceNext': 'Fires once — on your next turn.',
  'pre.onceNearest': 'Fires once — on your upcoming turn.',

  'allin.confirm': 'Put in {amount|cr}',
  'allin.bodyBefore': 'You put in your entire available stack',
  'allin.bodyAfter': 'and make no more bets in this game. You can change your forecast until the common lock.',
  'allin.up': 'up',
  'allin.down': 'down',
  'allin.noDirection': 'not chosen',
  'allin.points': 'Preliminary number of points (required)',
  'allin.pointsPlaceholder': 'multiple of {tick}',
  'allin.pointsInvalid': 'A strictly positive number, a multiple of {tick}.',

  'chart.myForecast': 'my forecast',
  'chart.scaleHidden': 'Price scale hidden until round 2 · units normalised',
  'chart.waiting': 'Waiting for index data…',
  'chart.hide': 'Hide',
  'chart.show': 'Show',
  'chart.period': 'period',
  'chart.indicators': 'Indicators',
  'chart.activity': 'Activity',

  'settle.aria': 'Game result',
  'settle.cancelled': 'Game cancelled',
  'settle.walkover': 'Only one participant left',
  'settle.title': 'Settlement',
  'settle.refundedNote': 'antes returned, no commission taken',
  'settle.myNet': 'Your net result',
  'settle.composition': 'Index composition:',
  'settle.colPlayer': 'Player',
  'settle.colForecast': 'Forecast',
  'settle.colError': 'Error',
  'settle.colContributed': 'Put in',
  'settle.colPayout': 'Payout',
  'settle.colRefund': 'Refund',
  'settle.colNet': 'Net',
  'settle.folded': 'fold',
  'settle.wrongDirection': 'wrong direction',
  'settle.pots': 'Pots',
  'settle.colPot': 'Pot',
  'settle.colAmount': 'Amount',
  'settle.colCommission': 'Commission',
  'settle.colRecipients': 'Recipients (weight)',
  'settle.mainPot': 'Main',
  'settle.sidePot': 'Side pot {n}',
  'settle.potRefunded': 'returned to contributors',
  'settle.commissionByRound': 'Commission by round',
  'settle.colRound': 'Round',
  'settle.colNewContributions': 'New contributions',
  'settle.withAntes': 'incl. antes',
  'settle.cap': 'cap',
  'settle.toHouse': 'Withheld to the house account',
  'settle.reconciliation': 'Reconciliation: debited {debited|cr} = paid {paid|cr} + refunded {refunded|cr} + house {bank|cr}',
  'settle.noWinners': 'No winners.',

  'verify.title': 'Verifiability',
  'verify.commitmentPre': 'Commitment',
  'verify.commitmentPost': 'published before betting —',
  'verify.match': 'matches ✓',
  'verify.mismatch': 'does not match ✗',
  'verify.checking': 'verifying…',
  'verify.notRevealed': 'not revealed',
  'verify.hideSalt': 'Hide salt',
  'verify.showSalt': 'Parameters and salt',
  'verify.inBrowser': 'Verify in browser',
  'verify.download': 'Download verification package',
  'verify.packageError': 'Verification package: {error}',
  // ── режимы игры (0.8.0) ──
  'head.instrument': '{symbol} · price open',
  'controls.noticeChooseDirectionOpen': 'Choose the direction: it cannot be changed after round 1.',
  'controls.noticeNoDirectionLate': 'No direction chosen, and it can no longer be chosen: you will drop out at lock-in.',
  'controls.noticeFixedOpen': 'Direction fixed: only the number of points changes until the end of the game.',
  'controls.statusNextRoundPlain': 'Everyone has acted. The next betting round opens in {time}.',
  // ── режимы игры (0.8.0) ──
  'stage.open.r1': '1 · Direction',
  'stage.open.r1Hint': 'fixed afterwards',
  'stage.open.r2': '2 · Points',
  'stage.open.r2Hint': 'refine',
  'stage.open.r3': '3 · Points',
  'stage.open.r3Hint': 'final round',
};
